import $ from 'jquery';
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
$(document).ready(function(){
  var currentYear = new Date();
  $(".current-year").text(currentYear.getFullYear());

  $(".hero-slider-text").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    vertical: true,
    accesibility: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    pauseOnHover: false,
    pauseOnFocus: false
  });

  $(".news-feed-item-wrapper").slick({
    autoplay: false,
    autoplaySpeed: 15000,
    mobileFirst: true,
    prevArrow: '.arrow-next-cus',
    nextArrow: '.arrow-next-cus',
    responsive: [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
  
   $(".benefit-items").slick({
    autoplay: true,
    autoplaySpeed: 15000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".side-menu-trigger").click(function() {
    var textToggler = $(".side-menu-trigger span:first-of-type");
    var text = $(textToggler).text();
    $(textToggler).text(text === "Menu" ? "Close" : "Menu");
    $(".overlay").toggleClass("active");
    $(".page-header").toggleClass("hide");
  });
  
  $(".card-item").slick({
    autoplay: true,
    autoplaySpeed: 15000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $(".direksi, .advisor, .saham").click(function(event) {
    // console.log($(this).attr("class"));
    if($(this).attr("class") === "direksi") {
      $(".advisor").addClass("active");
      $(".direksi").removeClass("active");
      $(".saham").addClass("active");
    } else if($(this).attr("class") === "advisor") {
      $(".advisor").removeClass("active");
      $(".direksi").addClass("active");
      $(".saham").addClass("active");
    } else if($(this).attr("class") === "saham") {
      $(".advisor").addClass("active");
      $(".direksi").addClass("active");
      $(".saham").removeClass("active");
    }
  });
  
  $(".view-as-list, .view-as-tile").click(function(event) {
    // console.log($(this).attr("class"));
    if($(this).attr("class") === "view-as-list") {
      $(".card-wrapper").addClass("change-to-list");
      $(".view-as-tile").removeClass("active");
      $(".view-as-list").addClass("active");
    } else if($(this).attr("class") === "view-as-tile") {
      $(".card-wrapper").removeClass("change-to-list");
      $(".view-as-list").removeClass("active");
      $(".view-as-tile").addClass("active");
    }
  });
});

$(document).scroll(function() {
  if($(document).scrollTop() > 200) {
    $(".main-nav").addClass("shrinked");
  } else {
    $(".main-nav").removeClass("shrinked");
  }
});

$(document).scroll(function() {
  if($(document).scrollTop() > 200) {
    $(".nav-warning").css("display", "none");
  } else {
    $(".nav-warning").css("display", "block");
  }
});

